module.exports = __webpack_public_path__ + "img/game-over.827c4bb4.png";